import {PlaceholderTiles} from '@aboutyou/ui-components';
import {useWishlistCount} from '@aboutyou/user';
import React from 'react';
import {WishlistItemGrid} from '../WishlistItemGrid/WishlistItemGrid';

export const WishlistLoadingComponent = ({
  onlyPlaceholder,
  className,
}: {
  onlyPlaceholder?: boolean;
  className?: string;
}) => {
  const {count} = useWishlistCount();

  if (onlyPlaceholder) {
    return (
      <>
        <PlaceholderTiles
          amount={count < 24 ? 24 : count}
          ctaVisible
          Comp="li"
        />
      </>
    );
  }

  // Should avoid rendering the footer before the product stream
  return (
    <WishlistItemGrid className={className}>
      <PlaceholderTiles amount={count < 24 ? 24 : count} ctaVisible Comp="li" />
    </WishlistItemGrid>
  );
};
